<template>
	<div class="ml20" style="height: 100%">
		<el-collapse v-model="activeNames" @change="handleChange">
			<el-collapse-item :id="'colla' + 1" :ref="'colla' + 1" title="一致性 Consistency" name="1">
				<template slot="title">
					<div class="stTitle flex flex">
						<div style="font-weight: 900; font-size: 18px">
							灭火及抢险救援器材放置点器材配置(必配)：
						</div>
						<div class="plus">
							<el-button size="small" type="primary" @click.stop="add('fireEquipmentPlacementPoint', 1)" v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
								>增加</el-button
							>
						</div>
					</div>
				</template>
				<div class="mt10">
					<table class="table table-bordered mt20" style="width: 100%">
						<thead>
							<tr>
								<th>序号</th>
								<th style="width:20%">消防设施</th>
								<th style="width:10%">数量</th>
								<th style="">备注</th>
								<th style="width:15%">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in list.fireEquipmentPlacementPoint">
								<td>{{ index + 1 }}</td>
								<td v-if="item.type == 1">{{ item.name }}</td>
								<td v-else>
									<el-input size="small" v-model="item.name"></el-input>
								</td>

								<td class="ml20">
									<el-input size="small" v-model="item.num"></el-input>
								</td>
								<td class="ml20">
									<el-input type="textarea" size="mini" v-model="item.remark"></el-input>
								</td>
								<td>
									<el-button
										v-if="item.type == 2"
										type="danger"
										@click="del('fireEquipmentPlacementPoint', index)"
										v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
										size="small"
										>删除</el-button
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</el-collapse-item>
			<el-collapse-item title="一致性 Consistency" name="2">
				<template slot="title">
					<div class="stTitle flex flex">
						<div style="font-weight: 900; font-size: 18px">
							消防员应急战备柜消防员基本防护装备配置(选配)：
						</div>
						<div class="plus">
							<el-button size="small" type="primary" @click.stop="add('fireBasicProtectiveEquipment', 2)" v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
								>增加</el-button
							>
						</div>
					</div>
				</template>

				<div class="mt10">
					<table class="table table-bordered mt20" style="width: 100%">
						<thead>
							<tr>
								<th>序号</th>
								<th style="width:20%">消防设施</th>
								<th style="width:10%">数量</th>
								<th style="">备注</th>
								<th style="width:15%">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in list.fireBasicProtectiveEquipment">
								<td>{{ index + 1 }}</td>
								<td v-if="item.type == 1">{{ item.name }}</td>
								<td v-else>
									<el-input size="small" v-model="item.name"></el-input>
								</td>

								<td class="ml20">
									<el-input size="small" v-model="item.num"></el-input>
								</td>
								<td class="ml20">
									<el-input type="textarea" size="mini" v-model="item.remark"></el-input>
								</td>
								<td>
									<el-button
										v-if="item.type == 2"
										type="danger"
										@click="del('fireBasicProtectiveEquipment', index)"
										v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
										size="small"
										>删除</el-button
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<!-- <div>
          <el-row>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireBasicProtectiveEquipment"
                v-if="
                  !(
                    index + 1 >
                    Math.ceil(list.fireBasicProtectiveEquipment.length / 2)
                  )
                "
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireBasicProtectiveEquipment"
                v-if="
                  index + 1 >
                  Math.ceil(list.fireBasicProtectiveEquipment.length / 2)
                "
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-button
                  v-if="item.type == 2"
                  type="danger"
                  @click="del('fireBasicProtectiveEquipment', index)"
                  v-hasPermi="[
                    'fireArchives:fireArchivesStationList:saveOrUpdate',
                  ]"
                  size="small"
                  >删除</el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </div> -->
			</el-collapse-item>
			<el-collapse-item title="一致性 Consistency" name="3">
				<template slot="title">
					<div class="stTitle flex">
						<div style="font-weight: 900; font-size: 18px">
							消防员应急战备柜灭火及抢险救援器材配置(选配)：
						</div>
						<div class="plus">
							<el-button size="small" type="primary" @click.stop="add('fireDmergencyRescueEquipment', 3)" v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
								>增加</el-button
							>
						</div>
					</div>
				</template>

				<div class="mt10">
					<table class="table table-bordered mt20" style="width: 100%">
						<thead>
							<tr>
								<th>序号</th>
								<th style="width:20%">消防设施</th>
								<th style="width:10%">数量</th>
								<th style="">备注</th>
								<th style="width:15%">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in list.fireDmergencyRescueEquipment">
								<td>{{ index + 1 }}</td>
								<td v-if="item.type == 1">{{ item.name }}</td>
								<td v-else>
									<el-input size="small" v-model="item.name"></el-input>
								</td>

								<td class="ml20">
									<el-input size="small" v-model="item.num"></el-input>
								</td>
								<td class="ml20">
									<el-input type="textarea" size="mini" v-model="item.remark"></el-input>
								</td>
								<td>
									<el-button
										v-if="item.type == 2"
										type="danger"
										v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']"
										@click="del('fireDmergencyRescueEquipment', index)"
										size="small"
										>删除</el-button
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
          <el-row>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireDmergencyRescueEquipment"
                v-if="
                  !(
                    index + 1 >
                    Math.ceil(list.fireDmergencyRescueEquipment.length / 2)
                  )
                "
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-button
                  v-if="item.type == 2"
                  type="danger"
                  @click="del('fireDmergencyRescueEquipment', index)"
                  v-hasPermi="[
                    'fireArchives:fireArchivesStationList:saveOrUpdate',
                  ]"
                  size="small"
                  >删除</el-button
                >
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireDmergencyRescueEquipment"
                v-if="
                  index + 1 >
                  Math.ceil(list.fireDmergencyRescueEquipment.length / 2)
                "
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-button
                  v-if="item.type == 2"
                  type="danger"
                  v-hasPermi="[
                    'fireArchives:fireArchivesStationList:saveOrUpdate',
                  ]"
                  @click="del('fireDmergencyRescueEquipment', index)"
                  size="small"
                  >删除</el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </div> -->
			</el-collapse-item>

			<el-collapse-item title="一致性 Consistency" name="4">
				<template slot="title">
					<div class="stTitle flex">
						<div style="font-weight: 900; font-size: 18px">
							消防车辆(选配)：
						</div>
						<div class="plus">
							<el-button size="small" type="primary" @click.stop="add('fireVehicle', 4)" v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']">增加</el-button>
						</div>
					</div>
				</template>
				<div class="mt10">
					<table class="table table-bordered mt20" style="width: 100%">
						<thead>
							<tr>
								<th>序号</th>
								<th style="width:20%">消防设施</th>
								<th style="width:10%">数量</th>
								<th style="">备注</th>
								<th style="width:15%">操作</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in list.fireVehicle">
								<td>{{ index + 1 }}</td>
								<td v-if="item.type == 1">{{ item.name }}</td>
								<td v-else>
									<el-input size="small" v-model="item.name"></el-input>
								</td>

								<td class="ml20">
									<el-input size="small" v-model="item.num"></el-input>
								</td>
								<td class="ml20">
									<el-input type="textarea" size="mini" v-model="item.remark"></el-input>
								</td>
								<td>
									<el-button v-if="item.type == 2" type="danger" @click="del('fireVehicle', index)" v-hasPermi="['fireArchives:fireArchivesStationList:saveOrUpdate']" size="small"
										>删除</el-button
									>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<!-- <div>
          <el-row>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireVehicle"
                v-if="!(index + 1 > Math.ceil(list.fireVehicle.length / 2))"
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-button
                  v-if="item.type == 2"
                  type="danger"
                  v-hasPermi="[
                    'fireArchives:fireArchivesStationList:saveOrUpdate',
                  ]"
                  @click="del('fireVehicle', index)"
                  size="small"
                  >删除</el-button
                >
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row
                class="mt10"
                v-for="(item, index) in list.fireVehicle"
                v-if="index + 1 > Math.ceil(list.fireVehicle.length / 2)"
              >
                <el-col :span="6">{{ index + 1 }}</el-col>
                <el-col :span="8" v-if="item.type == 1">{{ item.name }}</el-col>
                <el-col :span="8" v-else
                  ><el-input v-model="item.name"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-col :span="6" class="ml20"
                  ><el-input v-model="item.num"></el-input
                ></el-col>
                <el-button
                  v-if="item.type == 2"
                  type="danger"
                  @click="del('fireVehicle', index)"
                  v-hasPermi="[
                    'fireArchives:fireArchivesStationList:saveOrUpdate',
                  ]"
                  size="small"
                  >删除</el-button
                >
              </el-row>
            </el-col>
          </el-row>
        </div> -->
			</el-collapse-item>
		</el-collapse>

		<div class="stTitle flex">
			<div style="font-weight: 900; font-size: 18px">人员情况：</div>
			<div class="plus"></div>
		</div>

		<div class="personCont" style="max-height: 100%; width: 100%; text-align: left; overflow: auto">
			<div class="topTwo" style="width: 100%">
				<div v-for="(item, index) in selectList" style="width: 20%; margin-top: 20px">
					<el-row>
						<el-col :span="12">
							<el-select :disabled="index == 0" v-model="item.position" @change="changeSelect">
								<el-option label="无" v-if="index == 1" value="0"></el-option>
								<el-option v-for="(it, ind) in peopleList" :label="it.dictLabel" v-if="index == ind" :value="it.dictValue">{{ it.dictLabel }}</el-option>
							</el-select>
						</el-col>
						<el-col :span="8">
							<el-input :disabled="item.position == 0" v-model="item.name" @blur="changeSelect"></el-input>
						</el-col>
					</el-row>
					<el-row class="mt10 center">
						<el-col v-if="index == 1" :span="12">
							<el-button size="mini" class="ml10" @click="addTree('child')" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
								>增加 <i class="el-icon-caret-right" style="font-size:13px;"></i>
							</el-button>
						</el-col>
					</el-row>
				</div>
			</div>

			<div class="topTwo flex" style="width: 100%">
				<div style="width: 20%; margin-right: 10px; margin-top: 20px" v-if="selectList[1].child" v-for="(ite, inde) in selectList[1].child">
					<div v-for="(item, index) in ite" class="mt20" style="width: 100%">
						<el-row>
							<el-col :span="12">
								<el-select v-model="item.position" @change="changeSelect">
									<el-option v-for="(it, ind) in peopleList" v-if="!(it.dictValue == 1 || it.dictValue == 2)" :label="it.dictLabel" :value="it.dictValue">
										{{ it.dictLabel }}
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="8">
								<el-input v-model="item.name" @blur="changeSelect"></el-input>
							</el-col>
							<el-col :span="4" style="padding-top: 5px">
								<el-button size="mini" v-if="index == 0" type="danger" class="mt10" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']" @click="delTree(1, inde)"
									>删除</el-button
								>
								<el-button size="mini" v-else v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']" type="danger" @click="delTree(0, inde, index)">删除</el-button>
							</el-col>
						</el-row>
						<el-row v-if="index == 0" class="mt10 center">
							<el-col :span="12">
								<el-button size="mini" class="ml10" @click="addTree(inde)" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']"
									>增加
									<p class="el-icon-caret-bottom"></p
								></el-button>
							</el-col>
						</el-row>
					</div>
				</div>
			</div>
			<div class="center treecont" v-if="data.label" style="min-height: 500px">
				<vue2-org-tree :data="data" v-if="showtree" />
			</div>
		</div>

		<div class="center mt20">
			<el-button type="primary" @click="submit" v-hasPermi="['fireArchives:fireArchivesStation:saveOrUpdate']">保存</el-button>
			<!-- <el-button type="primary" @click="setTree">生成树</el-button> -->
		</div>
	</div>
</template>

<script>
	import { stringify } from "querystring";
	export default {
		props: ["dictValue", "dictType", "dict"],

		data() {
			return {
				peopleList: [], // 责任人，电工数组
				showtree: false,
				selectList: [
					{
						position: "1",
						name: "",
						value: "",
						companyNum: this.$route.query.id,
					},
					{
						position: "2",
						name: "",
						value: "",
						companyNum: this.$route.query.id,
						child: [],
					},
				], // 新增时的数组
				treeList: [], // 生成的树
				data: {},

				activeNames: ["1"],
				baseForm: {},
				peopleMap: {},
				list: {
					fireBasicProtectiveEquipment: [],
					fireDmergencyRescueEquipment: [],
					fireEquipmentPlacementPoint: [],
					fireVehicle: [],
				},
			};
		},
		created() {
			this.$get("/system/dict/data/notPageList", {
				dictType: "fire_personnel_situation",
			}).then((res) => {
				this.peopleList = res.data;
				var map = {};
				this.peopleList.map((it) => {
					map[it.dictValue] = it.dictLabel;
				});
				this.peopleMap = map;
				this.peopleMap[""] = "";
				this.peopleMap["0"] = "暂无人员";
				console.log(this.peopleMap);
			});
			this.getList();
		},
		watch: {
			dictValue(v) {
				this.getList();
			},
			showtree(val) {
				if (val) {
					setTimeout(() => {
						var d = document.getElementsByClassName("org-tree-node-label-inner");
						for (var i = 0; i < d.length; i++) {
							var str = d[i].innerHTML;
							d[i].innerHTML = str.split(":")[1] ? str.split(":")[0] + ":" + "<br/>" + str.split(":")[1] : str.split(":")[0];
						}
					}, 10);
				}
			},
		},
		methods: {
			setTree() {
				this.showtree = false;
				var tree = this.data;
				log(tree, "get treeList");
				tree.label = this.peopleMap[this.selectList[0].position] + ":" + this.selectList[0].name || "";
				tree.children = [];
				tree.position = this.selectList[0].position;
				tree.companyNum = this.selectList[0].companyNum;
				tree.majorItem = this.dictValue;
				tree.level = 1;
				// 二级 副站长
				var obj = {};
				obj.label = this.peopleMap[this.selectList[1].position] + ":" + this.selectList[1].name || "";
				obj.children = [];
				obj.position = this.selectList[1].position;
				obj.companyNum = this.selectList[0].companyNum;
				obj.majorItem = this.dictValue;
				obj.level = 2;
				if (obj.label.indexOf("暂无人员") > -1) {
					obj.label = "暂无人员";
				}
				tree.children.push(obj);

				//遍历已选择
				this.selectList[1].child.map((item, index) => {
					var obj2 = {
						label: this.peopleMap[item[0].position] + ":" + item[0].name || "",
						children: [],
						position: item[0].position,
						companyNum: item[0].companyNum,
						majorItem: this.dictValue,
						level: 3,
					};
					if (obj2.label.indexOf("暂无人员") > -1) {
						obj2label = "暂无人员";
					}
					obj.children.push(obj2);
					item.map((it, index) => {
						if (index > 0) {
							obj2.children.push({
								label: it.position == 0 ? "暂无人员" : this.peopleMap[it.position] + ":" + it.name || "",
								position: it.position,
								companyNum: it.companyNum,
								majorItem: this.dictValue,
								level: 4,
							});
						}
					});
				});
				console.log(this.data);
				this.$set(this, "data", tree);
				setTimeout(() => {
					this.showtree = true;
				}, 100);
			},
			addTree(e) {
				if (e == "child") {
					if (this.selectList[1].child.length >= 5) {
						this.$message.warning("最多增加5人");
						return;
					}
					this.selectList[1].child.push([
						{
							position: "",
							name: "",
							value: "",
							companyNum: this.$route.query.id,
						},
					]);
				} else {
					if (this.selectList[1].child[e].length >= 4) {
						this.$message.warning("最多增加3人");
						return;
					}
					this.selectList[1].child[e].push({
						position: "",
						name: "",
						value: "",
						companyNum: this.$route.query.id,
					});
				}
				setTimeout(() => {
					this.setTree();
				}, 10);
			},
			delTree(e, inde, index) {
				if (e) {
					if (this.selectList[1].child.length <= 1) {
						this.$message.warning("请保留至少一组人员");
						return;
					}
					this.selectList[1].child.splice(inde, 1);
				} else {
					if (this.selectList[1].child[inde].length <= 1) {
						this.$message.warning("请保留至少一个人员");
						return;
					}
					this.selectList[1].child[inde].splice(index, 1);
				}
				setTimeout(() => {
					this.setTree();
				}, 10);
			},

			changeSelect() {
				// alert(1)
				setTimeout(() => {
					this.setTree();
				}, 10);
			},

			async submit() {
				console.log(this.list);

				var arr = [...this.list.fireBasicProtectiveEquipment, ...this.list.fireDmergencyRescueEquipment, ...this.list.fireEquipmentPlacementPoint, ...this.list.fireVehicle];
				console.log(arr);

				await this.$post("fireArchives/fireArchivesStationList", {
					companyNum: this.$route.query.id,
					fireArchivesStationListList: arr,
				}).then((res) => {
					console.log(res);
				});

				if (this.data.label) {
					await this.$post("/fireArchives/station", this.data).then((RES) => {
						console.log(RES);
						this.$message.success(RES.msg);
						this.getList();
					});
				} else {
					// this.$message.success("保存成功");
					 this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
					this.getList();
				}
			},
			add(formName, type) {
				this.activeNames = String(type);
				var obj = {
					belongList: type,
					companyNum: this.$route.query.id,
					name: "请输入名称",
					num: "",
					type: 2,
				};
				this.list[formName].push(obj);
			},
			del(formName, index) {
				this.list[formName].splice(index, 1);
			},
			handleChange(val) {},
			getList() {
				this.$get("/fireArchives/fireArchivesStationList/list", {
					companyNum: this.$route.query.id,
				}).then((res) => {
					console.log(res);
					this.list = res.data;
				});
				this.$get("/fireArchives/station/list", {
					companyNum: this.$route.query.id,
					majorItem: this.dictValue,
				}).then((res) => {
					console.log(res);
					var list = [];

					const check = (arr) => {
						arr.map((item, index) => {
							if (item.level == 1) {
								list[0] = {
									position: String(item.position),
									name: item.label.split(":")[1] || "",
									value: "",
									companyNum: this.$route.query.id,
								};
							} else if (item.level == 2) {
								list[1] = {
									position: String(item.position),
									name: item.label.split(":")[1] || "",
									value: "",
									companyNum: this.$route.query.id,
									child: [],
								};
							} else if (item.level == 3) {
								console.log(item);
								console.log(list[1].child);
								list[1].child.push([
									{
										position: String(item.position),
										name: item.label.split(":")[1] || "",
										value: "",
										companyNum: this.$route.query.id,
										child: [],
									},
								]);
								if (item.children && item.children.length) {
									console.log(item);
									console.log(list[1].child);
									item.children.map((it, ind) => {
										list[1].child[index].push({
											position: it.position,
											name: it.label.split(":")[1] || "",
											value: "",
											companyNum: this.$route.query.id,
											child: [],
										});
									});
								}
							}
							if (item.children) {
								check(item.children);
							}
						});
					};

					check([res.data[0]]);

					this.data = res.data.length ? res.data[0] : {};

					this.showtree = true;
					this.selectList = list;
				});
			},
		},
	};
</script>

<style scoped>
	.table-bordered {
		border: 1px solid #dddddd;
	}
	.table {
		width: 90%;
	}

	.table > tbody > tr > td,
	.table > tbody > tr > th,
	.table > tfoot > tr > td,
	.table > tfoot > tr > th,
	.table > thead > tr > td,
	.table > thead > tr > th {
		padding: 3px;
		vertical-align: center;
		text-align: center;
		border-top: 1px solid #fff;
		background: #ecf2f4;
	}
	.table-bordered > thead > tr > th,
	.table-bordered > tbody > tr > th,
	.table-bordered > tfoot > tr > th,
	.table-bordered > thead > tr > td,
	.table-bordered > tbody > tr > td,
	.table-bordered > tfoot > tr > td {
		border: 1px solid #fff;
	}
	.treecont {
		text-align: center;
		overflow: auto;
		margin-top: 50px;
		width: 100%;
	}
	.itemContent {
		width: 100%;
		display: flex;
		flex-direction: column;
		/* background: pink; */
		/* background: pink; */
	}
	.personCont {
		display: flex;
		flex-direction: column;
	}
</style>
